import React from "react";
import { usePageSetting } from "tsi-common-react/src/utils/settings";

import { getDocument } from "@thelabnyc/thelabui/src/utils/dom";

import { BreakPoint } from "../../../models/screen";
import { getViewportBreakpoint } from "../../../utils/detectMobile";

interface FinePrintProps {
    showFinePrint?: boolean;
}

export const FinePrint = ({
    showFinePrint,
}: FinePrintProps): React.JSX.Element | null => {
    const checkoutGenericFinePrint = usePageSetting(
        "checkout_generic_fine_print",
    );
    const content = usePageSetting("checkout_financing_fine_print") || "";
    const mobileContent =
        usePageSetting("checkout_financing_fine_print_mobile_content") || "";

    const isMobileWidth = () => {
        const currentBreakpoint = getViewportBreakpoint();
        return currentBreakpoint < BreakPoint.MEDIUM;
    };

    // This ensures that internal links within the terms & conditions legal language
    // in checkout open in new tabs, as per the TSI's request.
    const addTargetBlankToLinks = (htmlContent: string) => {
        const document = getDocument();
        if (!document) {
            return htmlContent;
        }

        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = htmlContent;

        const links = tempDiv.querySelectorAll("a");
        links.forEach((link) => {
            link.setAttribute("target", "_blank");
            link.setAttribute("rel", "noopener noreferrer");
        });

        return tempDiv.innerHTML;
    };

    const rawFinancingHtml =
        mobileContent.length > 0
            ? isMobileWidth()
                ? mobileContent
                : content
            : content;
    const processedFinancingHtml = addTargetBlankToLinks(rawFinancingHtml);

    const rawGenericHtml = checkoutGenericFinePrint || "";
    const processedGenericHtml = addTargetBlankToLinks(rawGenericHtml);

    return (
        <div className="financing-form__fine-print">
            <div dangerouslySetInnerHTML={{ __html: processedGenericHtml }} />
            {showFinePrint && (
                <div
                    dangerouslySetInnerHTML={{ __html: processedFinancingHtml }}
                />
            )}
        </div>
    );
};
